var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhy2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 74,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C4AB73",
    d: "M56.149 7.784 37.58.861c-3.088-1.148-8.148-1.148-11.237 0L7.777 7.784C3.497 9.376 0 14.411 0 18.928v27.508c0 4.369 2.902 10.108 6.437 12.736l16 11.885c5.247 3.924 13.88 3.924 19.126 0l16-11.885C61.098 56.544 64 50.805 64 46.436V18.928c-.074-4.517-3.572-9.552-7.851-11.144Zm-24.447 10.81c4.391 0 7.963 3.555 7.963 7.924 0 4.294-3.386 7.738-7.665 7.886h-.372c-4.465-.148-7.814-3.592-7.814-7.886-.037-4.369 3.535-7.923 7.888-7.923Zm8.41 34.544c-2.27 1.48-5.21 2.258-8.15 2.258-2.939 0-5.915-.74-8.148-2.258-2.121-1.407-3.274-3.333-3.312-5.443 0-2.073 1.191-4.072 3.312-5.48 4.502-2.961 11.833-2.961 16.335 0 2.12 1.407 3.312 3.333 3.312 5.443-.038 2.073-1.228 4.073-3.35 5.48Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhy2);
export default __webpack_public_path__ + "static/media/why_2.01920e3865a5a48b34f755c147e5fa2c.svg";
export { ForwardRef as ReactComponent };